import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import BackButton from 'components/BackButton/BackButton';
import { CustomerPersonalDataDto } from 'services/generated';
import { personalDataApi } from 'store/slices/personalData-api';
import { referencesApi } from 'store/slices/references-api';
import { preloadQueries } from 'utils/preloading';

export const Route = createFileRoute('/_authenticated/tax-information')({
  component: TaxInformationLayout,
  beforeLoad: async ({ location }) => {
    const data = await getPersonalData();
    if (
      data &&
      data.isComplete &&
      location.pathname !== '/tax-information/review-tax-information' &&
      location.pathname !== '/tax-information/edit-tax-information'
    ) {
      throw redirect({
        to: '/products',
      });
    }
  },
  loader: async () => {
    await preloadQueries(
      referencesApi.endpoints.getCountries.initiate(),
      personalDataApi.endpoints.getPersonalData.initiate(),
    );
  },
});

function TaxInformationLayout() {
  return (
    <div className="h-full overflow-y-auto px-8">
      <BackButton
        className={
          'w-full text-left mt-1 ml-0 pl-6 lg:mt-2 pt-2 lg:ml-0 lg:pl-0 lg:pt-0'
        }
      />
      <div className="w-full items-center flex flex-col">
        <div className="flex flex-col items-center mt-14 max-w-[500px] w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

async function getPersonalData() {
  const [res] = await preloadQueries(
    personalDataApi.endpoints.getPersonalData.initiate(),
  );

  return res?.data as CustomerPersonalDataDto | undefined;
}

export default TaxInformationLayout;
